import infoIcon from "../../assets/images/infoBlue.svg";
import successIcon from "../../assets/images/check-circle-filled.svg";
import errorIcon from "../../assets/images/error-filled.svg";
import { useEffect } from "react";
import "./CustomToast.scss";
import { t } from "i18next";

export const CustomToast = ({ displayData, setDisplayData, timeout }) => {
    const handleClose = () => {
        setDisplayData(null);
    };

    useEffect(() => {
        if (displayData) {
            const timer = setTimeout(() => {
                handleClose();
            }, timeout || 5000);
            return () => clearTimeout(timer);
        }
    }, [displayData, timeout]);

    const getToastIcon = () => {
        switch (displayData.severity) {
            case "success":
                return <img className="toast-icon" src={successIcon} />;
            case "error":
                return <img className="toast-icon" src={errorIcon} />;
            case "info":
                return <img className="toast-icon" src={infoIcon} />;
            default:
                return <img className="toast-icon" src={infoIcon} />;
        }
    };

    return displayData ? (
        <div className="portal-common-toast">
            {getToastIcon()}
            <div className="toast-content">
                <div className="toast-body">
                    <div className="toast-body-summary">{displayData.summary}</div>
                    <div className="toast-body-content">{displayData.detail}</div>
                </div>
                <label className="toast-dismiss" onClick={handleClose}>
                    {t("COMMON.DISMISS")}
                </label>
            </div>
        </div>
    ) : (
        <></>
    );
};
